<!-- STUDIO -->
<div *ngIf="((dailyCall$ | async) || (dolbyConversation$ | async)) && (session$ | async)">
  <sc-studio-nav> </sc-studio-nav>

  <div class="content">
    <sc-studio-sidebar
      *ngFor="let sidebar of leftSidebars; let i = index; trackBy: trackBySidebar"
      [sidebar]="sidebar"
      [class.sidebarOpen]="sidebar?.open ?? false"
      [sidebarIndex]="i">
    </sc-studio-sidebar>

    <div #canvasContainer class="canvas-container" [ngClass]="canvasHorizontalLayout ? 'horizontal-layout': ''">
      <sc-canvas
        *ngIf="(dolbyConversation$ | async) && (dolbyPrioritySpeakersArray$ | async).length > 0"
        [class.priority]="(dolbyPrioritySpeakersArray$ | async).length > 0 && (dolbyNonPrioritySpeakersArray$ | async).length > 0"
        [minAspectRatio]="1"
        [maxAspectRatio]="157 / 90"
        [fit]="dolbyPrioritySpeakersArrayObjectFit$ | async"
        [moreFPS]="isMobileDevice === false">
        <sc-dolby-participant
          *ngFor="let dolbyParticipant of dolbyPrioritySpeakersArray$ | async; trackBy: trackByParticipantDolby"
          [dolbyParticipant]="dolbyParticipant">
        </sc-dolby-participant>
      </sc-canvas>
      <sc-canvas
        *ngIf="(dolbyConversation$ | async) && (dolbyNonPrioritySpeakersArray$ | async).length > 0"
        [class.secondary]="
          (dolbyPrioritySpeakersArray$ | async).length > 0 && (dolbyNonPrioritySpeakersArray$ | async).length > 0
        "
        [minAspectRatio]="3 / 4"
        [maxAspectRatio]="157 / 90"
        [fit]="dolbyNonPrioritySpeakersArrayObjectFit$ | async"
        [moreFPS]="isMobileDevice === false">
        <sc-dolby-participant
          *ngFor="let dolbyParticipant of dolbyNonPrioritySpeakersArray$ | async; trackBy: trackByParticipantDolby"
          [dolbyParticipant]="dolbyParticipant">
        </sc-dolby-participant>
      </sc-canvas>

      <sc-canvas
        *ngIf="(dailyCall$ | async) && (dailyPrioritySpeakersArray$ | async).length > 0"
        [class.priority]="(dailyPrioritySpeakersArray$ | async).length > 0 && (dailyNonPrioritySpeakersArray$ | async).length > 0"
        [minAspectRatio]="1"
        [maxAspectRatio]="157 / 90"
        [fit]="dailyPrioritySpeakersArrayObjectFit$ | async"
        [moreFPS]="isMobileDevice === false">
        <sc-daily-participant
          *ngFor="let dailyParticipant of dailyPrioritySpeakersArray$ | async; trackBy: trackByParticipantDaily"
          [dailyParticipant]="dailyParticipant">
        </sc-daily-participant>
      </sc-canvas>
      <sc-canvas
        *ngIf="(dailyCall$ | async) && (dailyNonPrioritySpeakersArray$ | async).length > 0"
        [class.secondary]="
          (dailyPrioritySpeakersArray$ | async).length > 0 && (dailyNonPrioritySpeakersArray$ | async).length > 0
        "
        [minAspectRatio]="3 / 4"
        [maxAspectRatio]="157 / 90"
        [fit]="dailyNonPrioritySpeakersArrayObjectFit$ | async"
        [moreFPS]="isMobileDevice === false">
        <sc-daily-participant
          *ngFor="let dailyParticipant of dailyNonPrioritySpeakersArray$ | async; trackBy: trackByParticipantDaily"
          [dailyParticipant]="dailyParticipant">
        </sc-daily-participant>
      </sc-canvas>

      <div
        class="stage-empty"
        *ngIf="dailyCall$.value && ((dailyPrioritySpeakersArray$ | async).length === 0
        && (dailyNonPrioritySpeakersArray$ | async).length === 0) || dolbyConversation$.value && ((dolbyPrioritySpeakersArray$ | async).length === 0
        && (dolbyNonPrioritySpeakersArray$ | async).length === 0)
      ">
        <h4>No one's here</h4>
        <p>Wait for the others to join...</p>
      </div>

      <div class="recording-animation" *ngIf="recording$ | async"></div>
    </div>

    <sc-countdown *ngIf="recordingCountdown" [countdown]="recordingCountdown" color="#ff7272"></sc-countdown>

    <sc-studio-sidebar
      *ngFor="let sidebar of rightSidebars; let i = index; trackBy: trackBySidebar"
      [sidebar]="sidebar"
      [class.sidebarOpen]="sidebar?.open ?? false"
      [sidebarIndex]="
        i + (sidebarItems$ | async).length / 2
       ">
    </sc-studio-sidebar>
  </div>

  <sc-studio-controls> </sc-studio-controls>
</div>

<!-- JOINING -->
<div
  *ngIf="((session$?.value?.confType === 'daily' &&
  (dailyCall$ | async) === null) &&
  (dailyLeaving$ | async) !== true ||
  (session$?.value?.confType !== 'daily' &&
  (dolbyConversation$ | async) === null)) &&
  (dolbyLeaving$ | async) !== true"
  id="joining-container">
  <ion-content>
    <ion-grid>
      <!-- GREEN ROOM -->
      <ion-row *ngIf="!renderBackstage">
        <ion-col *ngIf="(user$ | async) && (session$ | async)" size="12" class="ion-no-padding">
          <sc-request-permission
            *ngIf="requestPermissionOpen"
            (dismiss)="closeRequestPermission($event)"></sc-request-permission>
          <sc-green-room *ngIf="greenRoomOpen"> </sc-green-room>
        </ion-col>
      </ion-row>

      <!-- BACKSTAGE -->
      <ion-row *ngIf="renderBackstage">
        <ion-col size="12" class="ion-no-padding">
          <sc-backstage-access [guestEmail]="guestEmail"></sc-backstage-access>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-content>
</div>

<sc-squadshot *ngIf="(squadshot$ | async)?.active"></sc-squadshot>

<audio id="zap" hidden="true">
  <source src="assets/audio/zap.mp3" type="audio/mpeg" />
</audio>
